import { CommandTrackingView } from "@/types/command-tracking.type";
import { ModuleCommandEnum } from "@/types/enums/module-command.enum";
import { ModuleCommandStatusEnum } from "@/types/enums/command-status.enum";

/**
 * Arrêt d'urgence "confirmé" : la commande PAUSE a été reçue par la gateway.
 * C'est l'état qui déclenche l'affichage du message "contactez le support"
 * (sheets action-in-progress / action-launcher / emergency-stop) ainsi que
 * le donut rouge sur la fiche parcelle.
 */
export const isEmergencyStopActive = (
  areaCommandTracking: CommandTrackingView
) =>
  areaCommandTracking.command === ModuleCommandEnum.PAUSE &&
  areaCommandTracking.workflowStatus ===
    ModuleCommandStatusEnum.RECEIVED_BY_GATEWAY;

/**
 * Arrêt d'urgence "en cours" : PAUSE envoyée mais pas encore acquittée par la
 * gateway → on affiche le loader sur le sheet dédié.
 */
export const isEmergencyStopPending = (
  areaCommandTracking: CommandTrackingView
) =>
  areaCommandTracking.command === ModuleCommandEnum.PAUSE &&
  areaCommandTracking.workflowStatus !==
    ModuleCommandStatusEnum.RECEIVED_BY_GATEWAY;
